<template>
	<div>
		<DeleteProfile
			v-if="showModal"
			@closeDeleteProfile="closeDeleteProfile($event)"
			@closeDeleteMessage="closeDeleteMessage($event)"
		></DeleteProfile>

		<div
			id="profile"
			class="tabcontent"
			style="display: block !important"
			v-bind:class="{ ' modal-backdrop': showModal }"
		>
			<div class="lightBubble absolute">
				<div class="bubbleImage"></div>
				<p class="typewriter">
					<vue-typewriter text="Vaš profil je že kar močan, a kakšna profilna anketa več bi ga gotovo še izboljšala in prinesla dodatne točke." v-if="numberOfProfileSurveyCompleted != 100" />
					<vue-typewriter text="Vaš profil je dosegel polno moč. Za pridobitev dodatnih točk, počakajte na kakšno novo tematsko anketo." v-else />
				</p>
			</div>
			<div class="content wp710">
				<div class="example">
					<h2>{{ user.name }} {{ user.surname }}</h2>
					<div class="flex" v-if="isHideNow">
						<span class="num">34</span>
						<span class="icon warpit_icon_Female"></span>
					</div>
					<a href="#" v-on:click.prevent="editProfile()" v-if="isHideNow">
						<span class="icon warpit_icon_edit"></span>
					</a>
					<div class="greyContent">
						<div class="linear-progress-container">
							<div class="progress-bar linear" data-percentage="46">
								<span
									class="transition"
									:style="{ width: progressBar + '%' }"
								></span>
							</div>
							<h4>
								{{ $t("profile.power_of_profile") }}
								<span class="percentage">{{ percent }} %</span>
							</h4>
						</div>
						<span class="blue" v-if="percent !== '100'">{{ $t("profile.power_of_profile_text_1") }}</span>
						<span class="blue" v-else>{{ $t("profile.power_of_profile_text_2") }}</span>
						<a
							v-if="numberOfProfileSurveyCompleted != 100"
							class="join hoverEffect"
							ref="joinButton1"
							v-on:mouseover="formUtilsMouseHoverEffect($event, 'joinButton1')"
							v-on:mouseout="formUtilsMouseHoverEffect($event, 'joinButton1')"
							href
							v-on:click.prevent="completeSurveysRequest()"
						>
							<label>{{ $t("profile.complete_survey") }}</label>
							<span
								class="effect"
								ref="effectButton1"
								v-bind:style="{ top: topX + 'px', left: leftX + 'px' }"
							></span>
						</a>
					</div>
				</div>
				<ul>
					<li>
						<!-- <a href="#" v-on:click.prevent="editProfile()">
							<span class="icon warpit_icon_edit"></span>
						</a> -->
						<small class="label">{{ $t("profile.title") }}</small>

						<span v-if="user.address">{{ user.address }}</span>
						<span v-else-if="user.street">{{ user.street }}</span>

						<span>
							<template v-if="user.postal_code">{{ user.postal_code }}</template>
							<template v-else-if="user.postCode">{{ user.postCode }}</template>
							{{ user.city }}
						</span>
						<small class="phoneNumber label">{{ $t("profile.mobile_number") }}</small>
						<span v-if="user.phoneNumber">+386 {{ normalize_phone(user.phoneNumber) }}</span>
					</li>
					<li>
						<a href="#" v-on:click.prevent="changeEmail()" v-if="isHideNow">
							<span class="icon warpit_icon_edit"></span>
						</a>
						<small class="label">{{ $t("profile.email") }}</small>
						<span>{{ user.email }}</span>
					</li>
					<li>
						<a class="txt" href="#" v-on:click.prevent="changePassword()">{{
							$t("profile.change_password")
						}}</a>
					</li>
					<li>
						<a class="txt" href="#" v-on:click.prevent="logoutProfile()">{{
							$t("profile.logout")
						}}</a>
					</li>
					<li>
						<h4>{{ $t("profile.delete_profile") }}</h4>
						<p>
							{{ $t("profile.delete_profile_text") }}
						</p>
						<div class="flex">
							<a class="txt" href v-on:click.prevent="showDeletePopupFrom()">{{
								$t("profile.delete_profile")
							}}</a>
							<span class="icon warpit_icon_opozorilo-w"></span>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
import DeleteProfile from "./DeletProfile";
import VueTypewriter from "@/components/VueTypewriter";
import { formUtilsMouseHoverEffect} from '@/utils/form_utils.js';


export default {
	data() {
		return {
			showModal: false,
			isHideNow: false,
			progressBar: 0,
			topX: 1,
			leftX: 1,
			notCompleted: true,
			numberOfProfileSurveyCompleted: "0",
		};
	},
	created() {
		var intval = setInterval(() => {
			if (this.progressBar < this.numberOfProfileSurveyCompleted)
				this.progressBar += 0.3;
			else clearInterval(intval);
		}, 10);
	},
	computed: {
		percent() {
			return this.progressBar.toFixed();
		},
		user() {
			return this.$store.getters["user/user"];
		},
		projects() {
			return this.$store.getters["user/projects"];
		},
	},
	components: {
		VueTypewriter,
		DeleteProfile,
	},
	mounted() {
		this.isProfileProject();
		if(this.$route.params.action !== undefined && this.$route.params.action === 'delete_account'){
			this.showDeletePopupFrom()
		}
	},
	methods: {
		formUtilsMouseHoverEffect,

		isProfileProject() {
			let profileProjectCount = 0;
			let completetedProfileProjectCount = 0;

			this.projects.forEach((project) => {
				project.custom_attributes.find((custom_attribute) => {
					if (custom_attribute.name === "type") {
						if (
							custom_attribute.value !== undefined &&
							custom_attribute.value == "profile"
						) {
							profileProjectCount++;
							if (project.qStatus == "1") {
								completetedProfileProjectCount++;
							}
						}
					}
				});
			});

			if (profileProjectCount == 0) {
				this.numberOfProfileSurveyCompleted = 0;
				return;
			}
			this.numberOfProfileSurveyCompleted =
				(completetedProfileProjectCount / profileProjectCount) * 100;
			return;
		},
		showDeletePopupFrom() {
			this.showModal = true;
			this.$emit("setOpacity");
		},
		closeDeleteMessage(){
			this.showModal = false;
			this.$emit("resetOpacity");
			this.$store.dispatch("user/logout");
			this.$router.push({ path: "home" });
		},
		closeDeleteProfile(confirmDeleteProfile) {
			if(this.$route.params.action !== undefined && this.$route.params.action === 'delete_account'){
				this.$route.params.action = '';
			}
			if(confirmDeleteProfile !== true){
				this.showModal = false;
				this.$emit("resetOpacity");
			}
			if (confirmDeleteProfile === true) {

				this.deleteProfile();
			}
		},
		completeSurveysRequest() {
			this.$router.push({
				name: "surveys",
				params: {},
			});
			return;
		},
		logoutProfile() {
			this.$store.dispatch("user/logout");
			this.$router.push({ path: "home" });
		},
		deleteProfile() {
			this.$http
				.post("api/v1/deleteAccountToken")
				.then(() => {})
				.catch(() => {
					console.log("deleteAccountToken Failed");
				});
		},
		changePassword() {
			this.$router.push({ path: "change-password" });
		},
		notificationSetting() {
			this.$router.push({ path: "notification-settings" });
		},
		editProfile() {
			this.$router.push({ path: "edit-profile" });
		},
		changeEmail() {
			this.$router.push({ path: "change-email" });
		},
		normalize_phone(phone) {
			if (phone) {
				phone = phone.replace(/[^\d]/g, "");

				//check if number length equals to 10
				if (phone.length == 11) {
					//reformat and return phone number
					return phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1 $2 $3");
				}
			}
			return phone;
		},
	},
};
</script>
<style scoped>
h2 {
	color: #000000 !important ;
}
.modal-backdrop {
	opacity: 0.2 !important;
}
</style>